/**
 * Per-field help text for tool forms. Single source of truth — both the
 * inline <HelpIcon> on the edit form and the right-sidebar Field Help drawer
 * on the /tools/new page read from this map (per entity-management
 * guidelines §4).
 */
export const TOOL_FIELD_HELP: Record<string, string> = {
  name: 'URL-safe identifier (lowercase, hyphens). Agents reference a tool by name in their system prompts, and workflow steps pin them here. Cannot be changed after creation.',

  version:
    'Semantic version. Bump when you change the input/output schema or behavior. Templates can pin to a specific version so prompt-level regressions do not silently ship.',

  category:
    'Coarse grouping used for filtering and UI color-coding. "market-data" reads external price/fundamentals data; "execution" writes to external systems; "analysis" computes in-process; "communication" sends messages; "code"/"vision"/"web" are self-explanatory.',

  description:
    "Plain-English summary of what this tool does and when an agent should invoke it. This text is embedded in the agent's system prompt — keep it to 2–3 sentences, action-oriented.",

  inputSchema:
    "JSON Schema (draft-07) describing the tool's parameters. The agent's LLM reads this schema to generate calls; a mismatch silently produces garbage. Required properties + type + description per property.",

  outputSchema:
    "JSON Schema describing the tool's return shape. Optional but recommended — downstream steps can use it to validate what they receive. Leave as `{}` when unstructured.",
};
